import React from "react";
import { IP } from "./../../../../../internalServer"

const AssessmentCompletedList = ({ completeList, setClick }) => {
  const myList = [completeList];
  const totalLength = myList
    .map((array) => array.length)
    .reduce((sum, length) => sum + length, 0);
  console.log("completeList", completeList)
  return (
    <>
      <div className=" mt-2 p-0 student_list_box ">
        <div className=" student_list_header_colour"></div>
        <div className="px-2 mt-2 d-flex align-items-center justify-content-between student_list_header_box">
          <span>Assessment completed by: </span>
          {/* <img src="/images/cross.svg" alt="" style={{ cursor: "pointer" }} onClick={() => setClick(false)} /> */}
        </div>
        <div className="mx-2 mt-1 completed_student_count">
          Total {totalLength} Student
        </div>
        <div className="p-2 mt-1 mx-3  acti_pre_completed_list">
          {completeList &&
            completeList.length > 0 &&
            completeList.map((sListInfo) => (
              <div className="mb-2 gap-2 d-flex align-items-center  ">
                {<img
                  src={
                    sListInfo?.student_id
                      ? IP + sListInfo?.student_id?.profile_picture.replace(/^\./, "")
                      : sListInfo?.student_id?.gender === "M"
                        ? sListInfo?.student_id?.avatarProfile ? '/images/Boys/' + sListInfo?.student_id?.avatarProfile + '.webp'
                          : "/images/Student_boy_pic.png"
                        : sListInfo?.student_id?.gender === "F"
                          ? sListInfo?.student_id?.avatarProfile ? '/images/Girls/' + sListInfo?.student_id?.avatarProfile + '.webp'
                            : "/images/Student_girl_pic.png"
                          : "/images/default image.png"
                  }
                  alt="icon"
                  style={{ width: "20px", height: "20px", borderRadius: "50%" }}
                  className=""
                  key={sListInfo?.student_id?.avatarProfile}
                  onError={(e) => {
                    if (sListInfo?.student_id?.gender === "M") {
                      e.target.src = sListInfo?.student_id?.avatarProfile ? '/images/Boys/' + sListInfo?.student_id?.avatarProfile + '.webp' : "/images/Student_boy_pic.png"
                    } else if (sListInfo?.student_id?.gender === "F") {
                      e.target.src = sListInfo?.student_id?.avatarProfile ? '/images/Girls/' + sListInfo?.student_id?.avatarProfile + '.webp' : "/images/Student_girl_pic.png"
                    } else {
                      e.target.src = "/images/default image.png"
                    }
                  }}
                />}
                <span className=" acti_completed_s_name">
                  {sListInfo?.student_id?.name} | {' Code: ' + sListInfo?.student_id?.roll_number}
                </span>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default AssessmentCompletedList;
